import server from '@/utils/server'

const files = require.context('./modules', false, /.js$/)
files.keys().forEach(module => {
  const moduleName = module.replace(/(\.\/|\.js)/g, '')
  server.parseRouter(moduleName, files(module).default)
})

export default server
